/**
 * Shared form options - dropdown options and constants used across forms
 */

// US States + DC
export const stateOptions = [
  { value: 'AL', label: 'Alabama (AL)' },
  { value: 'AK', label: 'Alaska (AK)' },
  { value: 'AZ', label: 'Arizona (AZ)' },
  { value: 'AR', label: 'Arkansas (AR)' },
  { value: 'CA', label: 'California (CA)' },
  { value: 'CO', label: 'Colorado (CO)' },
  { value: 'CT', label: 'Connecticut (CT)' },
  { value: 'DE', label: 'Delaware (DE)' },
  { value: 'FL', label: 'Florida (FL)' },
  { value: 'GA', label: 'Georgia (GA)' },
  { value: 'HI', label: 'Hawaii (HI)' },
  { value: 'ID', label: 'Idaho (ID)' },
  { value: 'IL', label: 'Illinois (IL)' },
  { value: 'IN', label: 'Indiana (IN)' },
  { value: 'IA', label: 'Iowa (IA)' },
  { value: 'KS', label: 'Kansas (KS)' },
  { value: 'KY', label: 'Kentucky (KY)' },
  { value: 'LA', label: 'Louisiana (LA)' },
  { value: 'ME', label: 'Maine (ME)' },
  { value: 'MD', label: 'Maryland (MD)' },
  { value: 'MA', label: 'Massachusetts (MA)' },
  { value: 'MI', label: 'Michigan (MI)' },
  { value: 'MN', label: 'Minnesota (MN)' },
  { value: 'MS', label: 'Mississippi (MS)' },
  { value: 'MO', label: 'Missouri (MO)' },
  { value: 'MT', label: 'Montana (MT)' },
  { value: 'NE', label: 'Nebraska (NE)' },
  { value: 'NV', label: 'Nevada (NV)' },
  { value: 'NH', label: 'New Hampshire (NH)' },
  { value: 'NJ', label: 'New Jersey (NJ)' },
  { value: 'NM', label: 'New Mexico (NM)' },
  { value: 'NY', label: 'New York (NY)' },
  { value: 'NC', label: 'North Carolina (NC)' },
  { value: 'ND', label: 'North Dakota (ND)' },
  { value: 'OH', label: 'Ohio (OH)' },
  { value: 'OK', label: 'Oklahoma (OK)' },
  { value: 'OR', label: 'Oregon (OR)' },
  { value: 'PA', label: 'Pennsylvania (PA)' },
  { value: 'RI', label: 'Rhode Island (RI)' },
  { value: 'SC', label: 'South Carolina (SC)' },
  { value: 'SD', label: 'South Dakota (SD)' },
  { value: 'TN', label: 'Tennessee (TN)' },
  { value: 'TX', label: 'Texas (TX)' },
  { value: 'UT', label: 'Utah (UT)' },
  { value: 'VT', label: 'Vermont (VT)' },
  { value: 'VA', label: 'Virginia (VA)' },
  { value: 'WA', label: 'Washington (WA)' },
  { value: 'WV', label: 'West Virginia (WV)' },
  { value: 'WI', label: 'Wisconsin (WI)' },
  { value: 'WY', label: 'Wyoming (WY)' },
  { value: 'DC', label: 'Washington DC (DC)' },
];

// Business entity types
export const businessTypeOptions = [
  'LLC',
  'Corporation',
  'S-Corporation',
  'Sole Proprietorship',
  'Partnership',
  'Other',
];

// Primary operations (for contractors)
export const primaryOperationOptions = [
  'Tree Service (including removal, trimming, pruning, stump grinding)',
  'Landscape / Lawn Care (no tree work)',
  'Excavation',
  'Land Clearing (not logging)',
  'Residential General Contractor',
  'Commercial General Contractor',
  'Trade Contractor (Electrical, Plumbing, HVAC, etc.)',
  'Paving / Grading',
  'Concrete Construction',
  'Street and Road Construction',
  'Sewer and Water Main Construction',
  'Highway / Overpass Construction',
  'Wrecking / Demolition',
  'Agricultural / Farming',
  'Other',
];

// Deductible options
export const deductibleOptions = [
  '$500',
  '$1,000',
  '$2,500',
  '$5,000',
  '$10,000',
  '$25,000',
];

// Yes/No options (for consistency)
export const yesNoOptions = ['Yes', 'No'];

// ============================================
// COMMERCIAL AUTO FORM OPTIONS
// ============================================

// Legal entity types (merged from Hartford, Nationwide, BTIS)
export const legalEntityOptions = [
  'Individual / Sole Proprietorship',
  'LLC',
  'Corporation',
  'S-Corporation',
  'Partnership',
  'Other',
];

// Business operations check (Hartford)
export const businessOperationsCheckOptions = [
  'General Contractor',
  '>50% New Construction',
  'Asbestos/Mold Work',
  'Demolition Work',
  'None of the Above',
];

// Prior carrier options
export const priorCarrierOptions = [
  'No Prior Coverage',
  'Progressive',
  'Travelers',
  'Liberty Mutual',
  'State Farm',
  'Nationwide',
  'GEICO',
  'The Hartford',
  'BTIS',
  'Allstate',
  'Farmers',
  'USAA',
  'Other',
];

// Existing policies with other carriers
export const hartfordPolicyOptions = [
  'Business Owners Policy',
  'Workers\' Compensation',
  'Neither',
];

// Claim status options
export const claimStatusOptions = ['Open', 'Closed'];

// Prior policy type
export const priorPolicyTypeOptions = ['Personal', 'Commercial'];

// Vehicle body type options (merged from Hartford + BTIS)
export const bodyTypeOptions = [
  'Pick Up',
  'Private Passenger / Sedan',
  'SUV',
  'Cargo Van',
  'Box/Straight Truck',
  'Flatbed',
  'Dump Truck',
  'Utility Vehicle',
  'Bucket Truck',
  'Stake Bed',
  'Water Truck',
  'Trailer',
  'Other',
];

// Vehicle class options (Nationwide)
export const vehicleClassOptions = [
  'Private Passenger',
  'Light Truck (0-10,000 lbs GVW)',
  'Medium Truck (10,001-20,000 lbs GVW)',
  'Heavy Truck (20,001-45,000 lbs GVW)',
  'Extra-Heavy Truck (45,001+ lbs GVW)',
  'Trailer',
];

// Hitch type options (BTIS - for pickups)
export const hitchTypeOptions = [
  'Bumper Hitch',
  '5th Wheel',
  'Gooseneck/Ball in Bed',
  'Tow Boom',
  'None',
];

// Driving radius options
export const drivingRadiusOptions = [
  'Local (0-50 miles)',
  'Intermediate (51-200 miles)',
  'Long Distance (200+ miles)',
];

// Vehicle usage options
export const vehicleUsageOptions = [
  'Service',
  'Retail',
  'Commercial',
  'Business Only',
];

// Vehicle registered to options
export const vehicleRegisteredToOptions = [
  'Named Insured / Business Name',
  'Lessor',
  'Individual Owner',
  'Other',
];

// Auto deductible options (comp/collision)
export const autoDeductibleOptions = [
  '$250',
  '$500',
  '$1,000',
  '$2,500',
  '$5,000',
];

// Sex options
export const sexOptions = ['Male', 'Female'];

// Marital status options (BTIS)
export const maritalStatusOptions = [
  'Single',
  'Married',
  'Widowed',
  'Divorced',
  'Separated',
];

// License type options (BTIS)
export const licenseTypeOptions = ['State', 'Foreign'];

// Liability limit options (merged - BTIS has most granular)
export const liabilityLimitOptions = [
  '$10,000/$20,000 (10/20)',
  '$15,000/$30,000 (15/30)',
  '$25,000/$50,000 (25/50)',
  '$30,000/$60,000 (30/60)',
  '$50,000/$100,000 (50/100)',
  '$100,000/$300,000 (100/300)',
  '$250,000/$500,000 (250/500)',
  '$300,000 CSL',
  '$500,000 CSL',
  '$750,000 CSL',
  '$1,000,000 CSL',
];

// Medical payments options (BTIS)
export const medPayOptions = [
  'No Coverage',
  '$500',
  '$1,000',
  '$2,000',
  '$5,000',
  '$10,000',
];

// UM/UIM limit options
export const umLimitOptions = [
  'No Coverage / Reject',
  'Match Liability',
  '$10,000/$20,000',
  '$15,000/$30,000',
  '$25,000/$50,000',
  '$50,000/$100,000',
  '$100,000/$300,000',
  '$250,000/$500,000',
  '$300,000 CSL',
  '$500,000 CSL',
  '$1,000,000 CSL',
];

// Covered auto symbols options
export const coveredAutoSymbolOptions = [
  'Symbol 1 - Any Auto',
  'Symbol 2 - Owned Autos Only',
  'Symbol 7 - Specifically Described Autos',
  'Symbol 8 - Hired Autos Only',
  'Symbol 9 - Non-Owned Autos Only',
];

// Rental reimbursement limit options (BTIS)
export const rentalReimbursementLimitOptions = [
  '$30/day up to $900',
  '$40/day up to $1,200',
  '$50/day up to $1,500',
  '$60/day up to $1,800',
  '$70/day up to $2,100',
];

// Cargo coverage options (BTIS)
export const cargoLimitOptions = [
  '$10,000 limit / $500 deductible',
  '$25,000 limit / $500 deductible',
  '$50,000 limit / $500 deductible',
  '$10,000 limit / $1,000 deductible',
  '$25,000 limit / $1,000 deductible',
  '$50,000 limit / $1,000 deductible',
  '$100,000 limit / $1,000 deductible',
];

// Filing type options (Hartford)
export const filingTypeOptions = [
  'MCS-90',
  'BMC-91',
  'DMV-65',
  'Other',
];

// Plow location options (Hartford)
export const plowLocationOptions = [
  'Airports',
  'Public Streets',
  'Highways/Interstates',
  'Residential Properties',
  'Commercial Properties',
  'Other',
];

// Hazmat control options (Hartford)
export const hazmatControlOptions = [
  'Properly Secured in Vehicle',
  'Placards Used as Required',
  'Employees Trained on Handling',
  'Other',
];
